import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import '../landing-styles.css'

export default class Feature extends Component {

  render() {

    return (
        <Row center='xs'>
          <Col lg={6} xs={12}>
            <Row start='xs' middle='xs'>
              <Col lg={6} xs={12}>
                <div className='info-image-container' id={this.props.image} />
              </Col>
              <Col lg={6} xs={12} last={this.props.stagger === true ? 'xs' : null} first={this.props.stagger === true ? 'md' : null}>
                <h3>{this.props.headingText}</h3>
                <p>{this.props.description}</p>
              </Col>
            </Row>
          </Col>
        </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Views/Landing/Feature/Feature.js